module.exports = __webpack_public_path__ + "img/Kh.6e7f260d.png";